import { createSlice } from "@reduxjs/toolkit";
import { addChargerBookingsAPI } from "../../actions/chargerBookings/addChargerBookings";

const initialState = {
  addChargerBookings: {},
  loading: false,
  error: null,
};

const addChargerBookingsSlice = createSlice({
  name: "addChargerBookings",
  initialState,
  reducers: {
    resetUserData: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addChargerBookingsAPI.pending, (state) => {
        state.loading = true;
      })
      .addCase(addChargerBookingsAPI.fulfilled, (state, action) => {
        state.addChargerBookings = action.payload.data;
        state.loading = false;
      })
      .addCase(addChargerBookingsAPI.rejected, (state, action) => {
        state.error = action.payload.error;
        state.loading = false;
      });
  },
});

export const { resetUserData } = addChargerBookingsSlice.actions;
export default addChargerBookingsSlice.reducer;
